import { Button } from '@customerio/pluma-components/react';
import { useDataDrivenSegmentsAllotted, useRefetchSegmentQuota } from '@/services/db/environment/segment-limit';
import { useAddonPurchase } from '../hooks/use-addon-purchase';
import { FlexMark } from './flex-mark';
import * as styles from './segments-addon-button.css';

/**
 * The Credits Lifecycle prototype's "Flex add-on" tag, offered at the data-driven segment cap. It is a small Pluma
 * Button because Pluma's Badge and Tag are not actions.
 */
export function SegmentsAddonButton() {
  const { openAddon } = useAddonPurchase();
  const includedCount = useDataDrivenSegmentsAllotted();
  const refetchSegmentQuota = useRefetchSegmentQuota();

  const openSegmentsAddon = async () => {
    if (includedCount == null) return;
    const purchase = await openAddon({ request: { key: 'segments', includedCount } });
    if (purchase != null) await refetchSegmentQuota();
  };

  return (
    <Button className={styles.flexTag} size="sm" elementBefore={<FlexMark />} onClick={() => void openSegmentsAddon()}>
      Flex add-on
    </Button>
  );
}
